# import { default as WebModule__Content } from 'models/modulor/web_module/content'
#
# export class FeaturedEverydayLife extends WebModule__Content
#   @defaults =
#     debug: false
#     name: 'FeaturedEverydayLifeModule'
#
#   @selector: ".featured_everyday_life_module"
#
#   on_init: ->
#     console.log 'init' if @options.debug
#
# FeaturedEverydayLife.register()
